import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

// ✅ Amplify configurato PRIMA del bootstrap
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.auth.userPoolId,
      userPoolClientId: environment.auth.userPoolWebClientId,
      identityPoolId: environment.auth.identityPoolId,
      loginWith: {
        oauth: environment.auth.oauth
      }
    }
  }
});

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    ...appConfig.providers,
  ],
}).catch(err => console.error(err));